<template>
  <div class="big-box">
    <div class="box-research">
      <myXgplayer
        :needLogined="true"
        @videoPlay="PlayNumber"
        v-if="props.info.video_url"
        :width="mydata.video.width"
        :height="mydata.video.height"
        :url="completeUrl(props.info.video_url)"
        :poster="props.info.image ? completeUrl(props.info.image) : ''"
      ></myXgplayer>
      <div
        v-else
        style="
          width: 375px;
          height: 201px;
          border: 1px solid #999999;
        "
      ></div>
      <div class="box-title">
        <p class="detail-title" style="cursor: pointer">
          {{ props.info.title }}
          <!-- 你好你好你好你好你好你好 -->
        </p>
        <div class="box-detail">
          <p>
            年级：
            <span>{{ byIdGetText(props.info.classes, "classes2") }}</span>
          </p>
          <p>
            学科：
            <span>{{ byIdGetText(props.info.subject, "subject") }}</span>
          </p>
          <p>
            时长：
            <span>{{ props.info.duration }}</span>
          </p>
          <p>
            播放：
            <span>{{ props.info.play_number }}</span>
          </p>
          <p>
            来源：
            <span>{{ props.info.source }}</span>
          </p>
          <p>
            关键词：
            <span v-for="(item, index) in props.info.tags" :key="index" style="margin-right:10px;">{{
              item.name
            }}</span>
          </p>
        </div>

        <slot name="collect"></slot>
        <!-- <el-button type="primary" @click="submitButton(info.id)"
          >查看详情</el-button
        > -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { completeUrl } from "@/utils/utils.js";
import myXgplayer from "@/components/myXgplayer/index.vue";
import { Calendar } from "@element-plus/icons-vue";
import { User } from "@element-plus/icons-vue";
import { Document } from "@element-plus/icons-vue";
import { reactive } from "vue";

import { useRouter } from "vue-router";

import dayjs from "dayjs";
import { articlePlayNumber } from "@/api/studentWorld/index.js"

const router = useRouter();

const mydata = reactive({
  //视频尺寸
  video: {
    width: "375px",
    height: "201px",
  },
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  classes2: JSON.parse(localStorage.getItem("classes2")) ?? [],
  subject: JSON.parse(localStorage.getItem("subject")) ?? [],

  number: false,
});

// 通过ID得到对应文字
function byIdGetText(id, key) {
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}

// let num = false;
// 在线学习-详情页面-视频播放量
function PlayNumber() {
  if (!mydata.number) {
    // 记得传递参数
    articlePlayNumber({
      id: props.info.id,
    }).then((res) => {
      // console.log(res.data, "接口成功了");
    });
  }
  mydata.number = true;
}
</script>

<style scoped lang="scss">
.big-box {
  width: 100%;
  // height: 333px !important;
  // border: 1px solid red;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 0px;

  // background-color: red !important;
  .box-research {
    // display: flex;
    // height:479px;
    // border: 1px solid red;
    // padding-bottom:60px;
  }

  // width: 1200px;
  // height: 288px;
  // margin: 0 auto;
  // //  border-top:1px solid #CCCCCC;
  // // border: 1px solid rgb(21, 255, 0);
  // background-color: #ffffff;
  // padding: 30px;
  // border-radius: 8px;

  // width: 1200px;
  // height: 333px !important;
  // // border: 1px solid red;
  // padding: 0px;
  img {
    width: 343px;
    height: 201px;
    margin-right: 24px;
  }
  :deep(.box-title) {
    width: 343px;
    margin: 0 auto;
    // border: 1px solid rgb(179, 255, 0);

    // margin-bottom:40px;
  }
  .detail-title {
    min-height: 28px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: #333333;
    margin-top:10px;

    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;

    cursor: default !important;
  }
  .box-detail {
    // width: 567px;
    margin-top: 18px;

    p {
      font-size: 14px;
      font-weight: 400;
      // color: #b81c1c;
      margin-bottom: 8px;
      // line-height: 30px;
      white-space: nowrap; //不折行
      text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;
      color: #666666;
    }
    p:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
  }

 :deep(.el-button.el-button--primary) {
    display: none;
  }
  :deep(.el-button.el-button--primary) {
    width: 134px;
    height: 35px;
    padding: 10px;
    border-radius: 30px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    > span {
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
  }
}
</style>
